import { type PropsWithChildren, type ReactNode } from "react";
import { cn } from "ui";

import { Page } from "src/layout";

interface SettingsPageProps extends PropsWithChildren {
  fullWidth?: boolean;
  title?: ReactNode;
}

export function SettingsPage(props: SettingsPageProps) {
  return (
    <Page>
      <div
        className={cn("mx-auto w-full", props.fullWidth ? null : "max-w-2xl")}
      >
        {props.title ? (
          <h1 className="text-2xl font-semibold">{props.title}</h1>
        ) : null}
        <div className={cn(props.title ? "mt-6" : null)}>{props.children}</div>
      </div>
    </Page>
  );
}
